import { short_label as shortLabel } from './instant';
import { DEFAULT_CORNER } from '../../util_components/instant_alert/instant_popup_storage';
import { assigned_line as assignedLine } from '../../util_components/instant_alert/instant_alert_entries';
import type { InstantEntry } from '../../util_components/instant_alert/instant_alert_entries';
import type { InstantAlertConfig } from '../../util_components/instant_alert/types';

// Fired on window when this rep's claim proves a task is no longer pending.
export const INSTANT_GONE_EVENT = 'sales-task:instant-gone';

// Fired on window when this tab's form releases, loses or hands off a claim.
export const SALES_CLAIM_CHANGED_EVENT = 'sales-task:claim-changed';

export const POPUP_STORAGE_KEY_PREFIX = 'sales_task_instant_popup_v1';

// Mirrors goserver's SALES-only claim gate.
export const SALES_CLAIM_ROLES = ['SALES'];

// L3 tasks belong to the student's owner and pop up for all L3s; L1/L2 are pool work. Pending rows are
// unclaimed by definition, so no claimer is shown. A row without a level
// predates tiering. Leave status is list-only.
export const sales_meta_line = (entry: InstantEntry): string => {
  const level = entry.level || '';
  if (!level) return assignedLine(entry);
  const head = [level, entry.priority].filter(Boolean).join(' · ');
  if (level === 'L3') return `${head} · owner: ${entry.owner_name || 'No owner'}`;
  return head;
};

export const SALES_INSTANT_ALERT: InstantAlertConfig = {
  pendingPath: '/v2/sales_task_list/instant_pending',
  alertEventPath: '/v2/sales_task_list/alert_event',
  alertEventBody: (uuid, eventType) => ({ task_uuid: uuid, event_type: eventType }),
  listPath: '/sales-task-list',
  formHref: (uuid) => `/sales-task-form?uuid=${encodeURIComponent(uuid)}`,
  relayItemType: 'instant_task',
  relayClearedType: 'instant_task_cleared',
  capabilityKey: 'is_sales',
  activeKey: 'on_shift',
  metaLine: sales_meta_line,
  storagePrefix: POPUP_STORAGE_KEY_PREFIX,
  defaultCorner: DEFAULT_CORNER,
  goneEvent: INSTANT_GONE_EVENT,
  normalize: (raw) => raw as unknown as InstantEntry,
  entryLabel: (entry) => shortLabel(entry.task_type, entry.task_label),
  title: 'Instant Task Alert',
  nounSingular: 'instant task',
  nounPlural: 'instant tasks',
  openLabel: 'Open task →',
  testIdPrefix: 'instant-alert'
};
